import React, {useState} from 'react';
import {Button} from '@mui/material';
import {finalize} from 'rxjs';
import AlertComponent from '@components/modal/Alert.component';
import {jobsInvoiceService} from '@store/invoices/jobsInvoice';
import {useParams} from 'react-router-dom';
import {useSnackbar} from 'notistack';
import {useTranslation} from 'react-i18next';

export interface ConfirmJobInvoiceValidationModalProps {
  handleClose: () => void;
  handleSuccess: () => void;
}

const ConfirmJobInvoiceValidationModal = (props: ConfirmJobInvoiceValidationModalProps) => {
  const {handleClose, handleSuccess} = props;

  const {jobInvoiceId} = useParams();
  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation();

  const [loading, setLoading] = useState(false);

  const handleValidate = () => {
    if (!jobInvoiceId) return;
    setLoading(true);
    jobsInvoiceService.validateJobInvoice(jobInvoiceId).pipe(finalize(() => setLoading(false))).subscribe({
      next: () => {
        enqueueSnackbar(t('invoices.invoicesValidation.details.success.validated'), {variant: 'success'});
        handleSuccess();
      },
      error: (err) => enqueueSnackbar(err.text, err.options),
    });
  };

  return (
    <AlertComponent
      title={t('invoices.invoicesValidation.details.confirm.title')}
      description={t('invoices.invoicesValidation.details.confirm.description')}
      handleClose={handleClose}
      actions={(
        <>
          <Button variant="outlined" color="primary" disabled={loading} onClick={handleClose}>
            {t('global.cancel')}
          </Button>
          <Button variant="contained" disabled={loading} color="primary" onClick={handleValidate}>
            {t('global.validate')}
          </Button>
        </>
      )}/>
  );
};

export default ConfirmJobInvoiceValidationModal;